import { Capacitor } from "@capacitor/core";
import { Plugins } from '@capacitor/core';
import { Badge } from '@robingenz/capacitor-badge';
import { LocalNotifications } from '@capacitor/local-notifications';

// ----------------------------- o
// https://github.com/robingenz/capacitor-badge

export default {
    async setBadge(number) {
        // only for mobile devices
        if (Capacitor.platform !== 'web') {
            // and for devices that support Badge
            const { isSupported } = await Badge.isSupported();
            if (isSupported) {
                await Badge.set({ count: number });
            }
            // push local notification about Badge count
            else {
                // only if badge number is greater than 1
                if(number > 0){
                    await LocalNotifications.schedule({
                        notifications: [
                            {
                                id: 1,
                                title: 'Nieprzeczytane powiadomienia',
                                body: 'Masz jeszcze do przeczytania ' + number + ' powiadomień',
                            }
                        ],
                    });
                }
            }
        }
    },
}